/**
 * Hazmat classification taxonomy utilities.
 * Maps canonical hazmat values from search-service to regulatory-friendly display labels.
 */

export const HAZMAT_CLASSIFICATION_LABELS: Record<string, string> = {
  fully_regulated: 'Fully Regulated',
  limited_quantity_regulated: 'Limited Quantity',
  limited_quantity_air: 'Limited Quantity (Air)',
  excepted_quantity: 'Excepted Quantity',
  small_battery_exception_ground: 'Small Battery Exception (Ground)',
  small_battery_exception_air: 'Small Battery Exception (Air)',
};

export const CANONICAL_HAZMAT_VALUES = Object.keys(HAZMAT_CLASSIFICATION_LABELS);

export const LEGACY_HAZMAT_ALIASES: Record<string, string> = {
  full_hazmat: 'fully_regulated',
  limited_quantity_hazmat: 'limited_quantity_regulated',
};

export function formatHazmatClassification(value: string): string {
  return HAZMAT_CLASSIFICATION_LABELS[value] ?? value;
}

export function isHazmatClassification(value: string): boolean {
  return value in HAZMAT_CLASSIFICATION_LABELS || value in LEGACY_HAZMAT_ALIASES || value === 'hazmat';
}

/**
 * Returns the first canonical hazmat category for a shipment.
 * Canonical categories are mutually exclusive per regulatory rules
 * (a shipment is one of: fully_regulated, limited_quantity_regulated, etc.),
 * so at most one match is expected.
 */
export function extractHazmatCategory(classifications: string[] | undefined): string | undefined {
  if (!classifications || classifications.length === 0) return undefined;
  const canonical = CANONICAL_HAZMAT_VALUES.filter((v) => classifications.includes(v));
  return canonical.length > 0 ? canonical[0] : undefined;
}
